export function isNumeric(testValue) {
  return !isNaN(testValue) && !/\s+/.test(testValue);
}
